import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/** Today as an <input type="date"> wants it, in the VIEWER'S timezone - never toISOString(), which reports yesterday late at night. */
export function todayISO() {
  return new Date().toLocaleDateString('en-CA');
}
